import {useQuery} from "@tanstack/react-query";

import {OrderDishItem} from "@globals/DailyOrders/interfaces";

import {getReview} from "../DishReviewService";

type UseShowDishReviewFromReturn = {
  orderItemForReview?: OrderDishItem;
};

export default function useShowDishReviewFrom(): UseShowDishReviewFromReturn {
  const {data} = useQuery({
    queryKey: ["show-dish-review-info"],
    queryFn: getReview,
  });

  return {
    orderItemForReview: data,
  };
}
